









































import { Vue, Component, Prop } from "vue-property-decorator";
import { DataTableHeader } from "vuetify";
import calendarModel from "@/models/calendar/calendarModel";

@Component
export default class CalendarTable extends Vue {
  @Prop(Array) private items!: Array<calendarModel>;
  @Prop(Boolean) private loading!: boolean;
  @Prop(Array) private headers!: Array<DataTableHeader<calendarModel>>;
}
